export class QPMJournal {
  constructor() {
    this.fJournalChanged = false;
    this.fPageMgr = null;

    this.fPageProps = null;
  }

  InitJournal(pageMgr) {
    this.fPageMgr = pageMgr;
  }

  JournalChanged() {
    return this.fJournalChanged;
  }

  JournalPageProps(pageProps) {
    this.fJournalChanged = true;
    this.fPageProps = pageProps;
  }

  Restore() {
    //  console.log("QPageMgrJournal:Restore:");

    var p = this.fPageMgr;
    var pp = this.fPageProps;

    var curpp = p.GetPageProps();
    this.fPageMgr.JournalPageProps(curpp);

    p.fPageWidth = pp.fPageWidth;
    p.fPageHeight = pp.fPageHeight;
    p.fPageOrientation = pp.fPageOrientation;
    //p.fAutoSizePDF = pp.fAutoSizePDF;

    p.fMargins = pp.fMargins.Clone();
    p.fShowMargins = pp.fShowMargins;
    p.fHeaderHeight = pp.fHeaderHeight;
    p.fFooterHeight = pp.fFooterHeight;
    p.fShowHeaderFooter = pp.fShowHeaderFooter;
    p.fBackgroundColor = pp.fBackgroundColor;
    p.fBackgroundColor2 = pp.fBackgroundColor2;

    p.fBackgroundFillMode = pp.fBackgroundFillMode;
  }
}
